import React, { useState, useEffect } from 'react';
import { get } from '../../../helpers/fetch';
import { buildURL } from '../../../helpers/urls';

const ApiVersion = () => {
  const [version, setVersion] = useState('Loading...');

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const url = buildURL('version');
        const response = await get(url);
        setVersion(response.version || 'unknown');
      } catch (error) {
        console.error('Failed to fetch API version:', error);
        setVersion('unknown');
      }
    };

    fetchVersion();
  }, []);

  return (
    <div style={{
      fontSize: '0.85rem',
      color: '#666',
      fontFamily: 'monospace',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    }}
    >
      <span style={{ fontWeight: 'normal', color: '#888', flexShrink: 0 }}>API Branch:</span>
      <span
        title={version}
      >
        {version}
      </span>
    </div>
  );
};

export default ApiVersion;

